/**
 * Surgical Intent: more of your hits are the good kind.
 */

import type { Perk } from '@/sim/progression/perkContract';

export const SURGICAL_INTENT = {
  id: 'surgicalIntent',
  branch: 'gunplay',
  tier: 3,
  title: 'Surgical Intent',
  blurb: 'Anatomy for the layman, chapter four: the parts that stop things working.',
  maxRanks: 3,
  minLevel: 17,
  requires: ['snapSight'],
  statGrants: {},
  effects: [{ field: 'criticalChance', perRank: 0.09, condition: null }],
  damageModifiers: [],
} as const satisfies Perk;
